import React from "react";
import { motion } from "framer-motion";

export default function ProblemStatement() {
  return (
    <section style={{ background: "#D7FF37" }} className="py-12 md:py-16">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span
            className="inline-block px-5 py-2 rounded-full text-sm font-bold mb-8"
            style={{
              color: "#c8f135",
              background: "#2a2f1a",
              border: "none",
            }}
          >
            כבר הצלחנו בחו&quot;ל
          </span>

          <h2
            className="font-bold mb-8 leading-tight"
            style={{
              fontSize: "clamp(1.75rem, 3vw, 3rem)",
              color: "#121212",
            }}
          >
            המערכת שבורה,
            <br />
            והגיע הזמן לתקן אותה
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="space-y-6"
        >
          <p className="text-base md:text-lg leading-relaxed" style={{ color: "#121212" }}>
            שוב נגמרו הכרטיסים תוך{" "}
            <span className="font-bold">60 שניות</span>?
          </p>
          <p className="text-base md:text-lg leading-relaxed" style={{ color: "#121212" }}>
            נאלצת לשלם{" "}
            <span className="font-bold">פי 3</span>{" "}
            באתרים מפוקפקים רק כדי להיות שם? זה לא מקרי. המערכת היום בנויה
            נגד האוהדים.
          </p>
          <p
            className="font-bold mt-8"
            style={{
              color: "#121212",
              fontSize: "clamp(1.5rem, 2.5vw, 2.5rem)",
              lineHeight: 1.3,
            }}
          >
            אנחנו כאן כדי לשנות
            <br />
            את יחסי הכוחות.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
